// @flow
import env from '../../environment';
import {getCreator, postCreator} from '../../http';

export const endpoints = Object.freeze({
  GET_STORE_INFORMATION: `${env.baseApiUrl}/ui/admin/store/information`,
  GET_STORE_PROFILE_INFORMATION: `${env.baseApiUrl}/ui/admin/store/profile-information`,
  GET_RESELLER_INFORMATION: `${env.baseApiUrl}/ui/admin/reseller/:resellerId/information`,
  SAVE_FACEBOOK_INTEGRATION: `${env.baseApiUrl}/ui/admin/store/facebook-integration`,
  FETCH_FACEBOOK_INTEGRATION: `${env.baseApiUrl}/ui/store/:storeId/facebook-integration`,
  SAVE_DOWNGRADE_INFORMATION: `${env.baseApiUrl}/ui/admin/store/downgrade-information`,
  GET_STORE_PRODUCT_SETTING: `${env.baseApiUrl}/ui/admin/store/product-setting`,
});

export const getStoreInformationApi = getCreator(
  endpoints.GET_STORE_INFORMATION
);
export const getStoreProfileInformationApi = getCreator(
  endpoints.GET_STORE_PROFILE_INFORMATION
);
export const getResellerInformationApi = getCreator(
  endpoints.GET_RESELLER_INFORMATION
);
export const saveFacebookIntegrationApi = postCreator(
  endpoints.SAVE_FACEBOOK_INTEGRATION
);
export const getFacebookIntegrationApi = getCreator(
  endpoints.FETCH_FACEBOOK_INTEGRATION
);
export const saveDowngradeInformationApi = postCreator(
  endpoints.SAVE_DOWNGRADE_INFORMATION
);
export const getStoreProductSettingApi = getCreator(
  endpoints.GET_STORE_PRODUCT_SETTING
);
export const saveStoreProductSettingApi = postCreator(
  endpoints.GET_STORE_PRODUCT_SETTING
);
